<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="panelOpen = false" v-if="panelOpen"></div>
        <transition name="slide">
            <div v-if="panelOpen" class="sidebar-panel order-1 order-lg-0">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: ['open'],
        data() {
            return {
                panelOpen: false
            }
        },
        watch: {
            open: {
                immediate: true,
                handler() {
                    this.panelOpen = this.open;
                }
            },
            panelOpen: {
                immediate: true,
                handler() {
                    this.$emit('change', this.panelOpen);
                }
            },
            '$route'() {
                this.panelOpen = false;
            }
        },
        updated() {
            let buttons = this.$el.getElementsByClassName('nav-item');

            for(let button of buttons) {
                button.onclick = () => this.panelOpen = false;
            }
        }
    }
</script>